<template>
  <div class="sign-up-wrapper" v-if="!isLoading">
    <div class="sign-up-header">
      <img
        class="logo"
        src="../../../public/custom/images/logo.svg"
        alt="Logo image"
        @click="goToMain()"
      />
      <img
        class="header-icon"
        src="../../../public/custom/images/header-icon.svg"
        alt="Header icon"
      />
    </div>
    <div class="sign-up-container">
      <div class="title">{{ $t("message.signUp.title") }}</div>
      <div class="description">{{ $t("message.signUp.description") }}</div>

      <div class="sign-up-block">
        <div class="sign-up-block-title">
          <div class="step-block">1.</div>
          <div class="step-block-desc">
            {{ $t("message.signUp.role.title") }}
          </div>
        </div>
        <div class="sign-up-block-container">
          <div class="large-input-container role-block">
            <div class="role-item">
              <base-radio-button
                :checked="userData.role === 'lender'"
                @click="userData.role = 'lender'"
              />
              <div class="role-item-desc" @click="userData.role = 'lender'">
                {{ $t('message.signUp.roleBlock.lender') }}
              </div>
            </div>
            <div class="role-item">
              <base-radio-button
                :disabled="false"
                :checked="userData.role === 'borrower'"
                @click="userData.role = 'borrower'"
              />
              <div class="role-item-desc" @click="userData.role = 'borrower'">
                {{ $t('message.signUp.roleBlock.borrower') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sign-up-block">
        <div class="sign-up-block-title">
          <div class="step-block">2.</div>
          <div class="step-block-desc">
            {{ $t("message.signUp.mainData.title") }}
          </div>
        </div>
        <div class="sign-up-block-container">
          <div class="middle-input-container">
            <base-text-input
              :default-value="userData.name_ru.family_name_ru"
              :label="$t('message.signUp.mainData.surname.title')"
              :disabled="signUpDisabledFields.family_name_ru"
              v-model="userData.name_ru.family_name_ru"
              :name="'surname'"
              :validate-rules="'surname'"
            />
          </div>
          <div class="middle-input-container">
            <base-text-input
              :default-value="userData.name_ru.given_name_ru"
              :label="$t('message.signUp.mainData.name.title')"
              :disabled="signUpDisabledFields.given_name_ru"
              v-model="userData.name_ru.given_name_ru"
              :name="'name'"
              :validate-rules="'name'"
            />
          </div>
          <div class="middle-input-container">
            <base-text-input
              :default-value="userData.name_ru.middle_name_ru"
              :label="$t('message.signUp.mainData.middleName.title')"
              :disabled="signUpDisabledFields.middle_name_ru"
              v-model="userData.name_ru.middle_name_ru"
              :name="'middleName'"
              :validate-rules="'middleName'"
            />
          </div>
        </div>

        <div class="sign-up-block-container">
          <div class="middle-input-container">
            <div class="input-wrapper">
              <div class="input-label">
                {{ $t("message.signUp.mainData.birthDate.title") }}
              </div>
              <div class="datepicker-block">
                <BaseDatepicker
                  :is-has-calendar-icon="false"
                  :placeholder="$t('message.signUp.mainData.birthDate.placeholder')"
                  :defaultValue="userData.birthdate"
                  v-model="userData.birthdate"
                  :disabled="signUpDisabledFields.birthdate"
                  :value-type="'YYYYMMDD'"
                  :format="'DD.MM.YYYY'"
                />
              </div>
              <div class="input-error-block"></div>
            </div>
          </div>

          <div class="middle-input-container">
            <base-text-input
              :default-value="userData.citizenship"
              :label="$t('message.signUp.mainData.citizenship.title')"
              :disabled="signUpDisabledFields.citizenship"
              v-model="userData.citizenship"
              :name="'citizenship'"
              :validate-rules="'citizenship'"
            />
          </div>

          <div class="middle-input-container">
            <div class="input-wrapper">
              <div class="input-label">
                {{ $t("message.signUp.mainData.gender.title") }}
              </div>
              <div class="gender-block">
                <div class="gender-item">
                  <BaseRadioButton
                    :disabled="true"
                    :checked="userData.sex === 'male'"
                  />
                  <div class="gender-name">{{ $t("message.signUp.mainData.gender.male") }}</div>
                </div>
                <div class="gender-item">
                  <BaseRadioButton
                    :disabled="true"
                    :checked="userData.sex === 'female'"
                  />
                  <div class="gender-name">{{ $t("message.signUp.mainData.gender.female") }}</div>
                </div>
              </div>
              <div class="input-error-block"></div>
            </div>
          </div>
        </div>

        <div class="sign-up-block-container">
          <div class="large-input-container">
            <base-textarea-input
              :disabled="signUpDisabledFields.birth_place_str"
              :default-value="userData.birth_place_str"
              v-model="userData.birth_place_str"
              :label="$t('message.signUp.mainData.birthPlace.title')"
              :placeholder="$t('message.signUp.mainData.birthPlace.placeholder')"
              :name="'birthPlace'"
              :validate-rules="'birthPlace'"
            />
          </div>
        </div>
      </div>

      <div class="sign-up-block">
        <div class="sign-up-block-title">
          <div class="step-block">3.</div>
          <div class="step-block-desc">
            {{ $t("message.signUp.idBlock.title") }}
          </div>
        </div>
        <div class="sign-up-block-container">
          <div class="middle-input-container">
            <base-text-input
              :default-value="userData.national_id_number"
              :label="$t('message.signUp.idBlock.idIdentification.title')"
              :disabled="signUpDisabledFields.national_id_number"
              v-model="userData.national_id_number"
              :name="'nationalIdNumber'"
              :validate-rules="'nationalIdNumber'"
            />
          </div>

          <div class="middle-input-container">
            <BaseSelect
              :label="$t('message.signUp.idBlock.mainDocument.title')"
              :default-value="userData.id_document.type"
              :options-list="CONSTANTS.MAIN_DOCUMENT_TYPE_LIST"
              :dictionary-path="'message.signUp.idBlock.mainDocument.list.'"
              v-model="userData.id_document.type"
              :disabled="signUpDisabledFields.type"
              :name="'mainDocument'"
            />
          </div>

          <div class="middle-input-container">
            <base-text-input
              :default-value="userData.id_document.seriesNumber"
              :label="$t('message.signUp.idBlock.seriesAndNumber.title')"
              :disabled="signUpDisabledFields.seriesNumber"
              v-model="userData.id_document.seriesNumber"
              :name="'idSeries'"
              :validate-rules="'idSeries'"
            />
          </div>
        </div>

        <div class="sign-up-block-container">
          <div class="middle-input-container">
            <div class="input-wrapper">
              <div class="input-label">
                {{ $t("message.signUp.idBlock.idDateIssue.title") }}
              </div>
              <div class="datepicker-block">
                <BaseDatepicker
                  :is-has-calendar-icon="false"
                  :placeholder="$t('message.signUp.idBlock.idDateIssue.placeholder')"
                  :defaultValue="userData.id_document.issueDate"
                  v-model="userData.id_document.issueDate"
                  :disabled="signUpDisabledFields.issueDate"
                  :value-type="'YYYYMMDD'"
                  :format="'DD.MM.YYYY'"
                />
              </div>
              <div class="input-error-block"></div>
            </div> 
          </div>

          <div class="middle-input-container">
            <div class="input-wrapper">
              <div class="input-label">
                {{ $t("message.signUp.idBlock.expireDate.title") }}
              </div>
              <div class="datepicker-block">
                <BaseDatepicker
                  :is-has-calendar-icon="false"
                  :placeholder="$t('message.signUp.idBlock.expireDate.placeholder')"
                  :defaultValue="userData.id_document.expireDate"
                  v-model="userData.id_document.expireDate"
                  :disabled="signUpDisabledFields.expireDate"
                  :value-type="'YYYYMMDD'"
                  :format="'DD.MM.YYYY'"
                />
              </div>
              <div class="input-error-block"></div>
            </div> 
          </div>

          <div class="middle-input-container"></div>
        </div>

        <div class="sign-up-block-container">
          <div class="large-input-container">
            <base-textarea-input
              :disabled="signUpDisabledFields.authority"
              :default-value="userData.id_document.authority"
              v-model="userData.id_document.authority"
              :label="$t('message.signUp.idBlock.idIssuedBy.title')"
              :placeholder="$t('message.signUp.idBlock.idIssuedBy.placeholder')"
              :name="'idIssuedBy'"
              :validate-rules="'idIssuedBy'"
            />
          </div>
        </div>
      </div>

      <div class="sign-up-block">
        <div class="sign-up-block-title">
          <div class="step-block">4.</div>
          <div class="step-block-desc">
            {{ $t("message.signUp.addressBlock.title") }}
          </div>
        </div>

        <div class="sign-up-block-container">
          <div class="large-input-container">
            <base-textarea-input
              :disabled="signUpDisabledFields.address_str"
              :default-value="userData.address_str"
              v-model="userData.address_str"
              :label="$t('message.signUp.addressBlock.registrationAdress.title')"
              :name="'registrationAdress'"
              :validate-rules="'registrationAdress'"
            />
          </div>
        </div>

        <div class="sign-up-block-container">
          <div class="large-input-container same-address-container">
            <base-radio-button
              :checked="isAddressLivingAndRegistrationTheSame"
              @click="isAddressLivingAndRegistrationTheSame = !isAddressLivingAndRegistrationTheSame"
            />
            <div class="same-address-title" @click="isAddressLivingAndRegistrationTheSame = !isAddressLivingAndRegistrationTheSame">{{ $t('message.signUp.addressBlock.registrationAdress.theSame') }}</div>
          </div>
        </div>

        <div class="sign-up-block-container">
          <div class="large-input-container">
            <base-textarea-input
              :disabled="isAddressLivingAndRegistrationTheSame"
              v-model="living_address_str"
              :label="$t('message.signUp.addressBlock.livingAddress.title')"
              :placeholder="$t('message.signUp.addressBlock.livingAddress.placeholder')"
              :name="'livingAddress'"
              :validate-rules="'livingAddress'"
            />
          </div>
        </div>
      </div>

      <div class="sign-up-block">
        <div class="sign-up-block-title">
          <div class="step-block">5.</div>
          <div class="step-block-desc">
            {{ $t("message.signUp.jobBlock.title") }}
          </div>
        </div>
        <div class="sign-up-block-container">
          <div class="middle-input-container">
            <BaseSelect
              :label="$t('message.signUp.jobBlock.typeOfEmployment.title')"
              :default-value="work_info.employment_type"
              :options-list="CONSTANTS.EMPLOYMENT_TYPE_LIST"
              :dictionary-path="'message.signUp.jobBlock.typeOfEmployment.list.'"
              v-model="work_info.employment_type"
              :name="'typeOfEmployment'"
            />
          </div>
          <div class="middle-input-container">
            <BaseSelect
              :label="$t('message.signUp.jobBlock.fieldOfEmployment.title')"
              :default-value="work_info.scope_of_employment_type"
              :options-list="CONSTANTS.SCOPE_OF_EMPLOYMENT_TYPE_LIST"
              :dictionary-path="'message.signUp.jobBlock.fieldOfEmployment.list.'"
              v-model="work_info.scope_of_employment_type"
              :name="'fieldOfEmployment'"
            />
          </div>
          <div class="middle-input-container"></div>
        </div>

        <div class="sign-up-block-container">
          <div class="large-input-container">
            <base-textarea-input
              v-model="work_info.organization_name"
              :label="$t('message.signUp.jobBlock.nameOfOrganization.title')"
              :name="'nameOfOrganization'"
              :validate-rules="'nameOfOrganization'"
            />
          </div>
        </div>

        <div class="sign-up-block-container">
          <div class="middle-input-container">
            <BaseSelect
              :label="$t('message.signUp.jobBlock.post.title')"
              :default-value="work_info.job_position_type"
              :options-list="CONSTANTS.POST_TYPE_LIST"
              :dictionary-path="'message.signUp.jobBlock.post.list.'"
              v-model="work_info.job_position_type"
              :name="'post'"
            />
          </div>
          <div class="middle-input-container">
            <base-text-input
              :label="$t('message.signUp.jobBlock.otherPositionType.title')"
              v-model="work_info.job_position_name"
              :name="'otherPositionType'"
              :validate-rules="'otherPositionType'"
              v-if="isOtherJobPositionType"
            />
          </div>
          <div class="middle-input-container"></div>
        </div>

        <div class="sign-up-block-container" v-if="userData.role === 'borrower'">
          <div class="middle-input-container">
            <base-text-input
              :label="$t('message.signUp.jobBlock.phoneNumber.title')"
              :placeholder="$t('message.signUp.jobBlock.phoneNumber.placeholder')"
              v-model="work_info.organization_phone_number"
              :name="'organizationPhoneNumber'"
              :validate-rules="'organizationPhoneNumber'"
              :mask-pattern="'+375 (##) ###-##-##'"
            />
          </div>
            <div class="middle-input-container">
              <div class="input-wrapper">
                <div class="input-label">
                  {{ $t('message.signUp.jobBlock.workExperience.title') }}
                </div>
                <div class="half-middle-input-block">
                  <base-text-input
                    :placeholder="$t('message.signUp.jobBlock.workExperience.placeholder')"
                    v-model="work_info.workExperience"
                    :name="'workExperience'"
                    :validate-rules="'workExperience'"
                    :mask-pattern="'####'"
                  />
                </div>
              </div>
            </div>
          <div class="middle-input-container"></div>
        </div>
      </div>

      <div class="sign-up-block" v-if="userData.role === 'borrower'">
        <div class="sign-up-block-title">
          <div class="step-block">6.</div>
          <div class="step-block-desc">
            {{ $t("message.signUp.extraBlock.title") }}
          </div>
        </div>
        <div class="sign-up-block-container">
          <div class="middle-input-container">
            <BaseSelect
              :label="$t('message.signUp.extraBlock.education.title')"
              :default-value="extra_user_info.education"
              :options-list="CONSTANTS.EDUCATION_TYPE_LIST"
              :dictionary-path="'message.signUp.extraBlock.education.list.'"
              v-model="extra_user_info.education"
              :name="'education'"
            />
          </div>
          <div class="middle-input-container">
            <BaseSelect
              :label="$t('message.signUp.extraBlock.familyStatus.title')"
              :default-value="extra_user_info.family_status"
              :options-list="CONSTANTS.FAMILY_STATUS_TYPE_LIST"
              :dictionary-path="'message.signUp.extraBlock.familyStatus.list.'"
              v-model="extra_user_info.family_status"
              :name="'familyStatus'"
            />
          </div>
          <div class="middle-input-container"></div>
        </div>

        <div class="sign-up-block-container row-radiobtn-container">
          <div class="middle-input-container">
            <div class="input-label extra-data-radiobtn-input-label">
              {{ $t("message.signUp.extraBlock.driversLicense.title") }}
            </div>
          </div>
          <div class="middle-input-container extra-radiobtn-block">
            <div class="role-item">
              <base-radio-button
                :checked="extra_user_info.drivers_license"
                @click="extra_user_info.drivers_license = true"
              />
              <div class="role-item-desc" @click="extra_user_info.drivers_license = true">
                {{ $t('message.signUp.extraBlock.driversLicense.yes') }}
              </div>
            </div>
            <div class="role-item">
              <base-radio-button
                :checked="!extra_user_info.drivers_license"
                @click="extra_user_info.drivers_license = false"
              />
              <div class="role-item-desc" @click="extra_user_info.drivers_license = false">
                {{ $t('message.signUp.extraBlock.driversLicense.no') }}
              </div>
            </div>
          </div>
          <div class="middle-input-container"></div>
        </div>

        <div class="sign-up-block-container row-radiobtn-container">
          <div class="middle-input-container">
            <div class="input-label extra-data-radiobtn-input-label">
              {{ $t("message.signUp.extraBlock.car.title") }}
            </div>
          </div>
          <div class="middle-input-container extra-radiobtn-block">
            <div class="role-item">
              <base-radio-button
                :checked="extra_user_info.car_owner"
                @click="extra_user_info.car_owner = true"
              />
              <div class="role-item-desc" @click="extra_user_info.car_owner = true">
                {{ $t('message.signUp.extraBlock.car.yes') }}
              </div>
            </div>
            <div class="role-item">
              <base-radio-button
                :checked="!extra_user_info.car_owner"
                @click="extra_user_info.car_owner = false"
              />
              <div class="role-item-desc" @click="extra_user_info.car_owner = false">
                {{ $t('message.signUp.extraBlock.car.no') }}
              </div>
            </div>
          </div>
          <div class="middle-input-container"></div>
        </div>

        <div class="sign-up-block-container row-radiobtn-container">
          <div class="middle-input-container">
            <div class="input-label extra-data-radiobtn-input-label">
              {{ $t("message.signUp.extraBlock.realEstate.title") }}
            </div>
          </div>
          <div class="middle-input-container extra-radiobtn-block">
            <div class="role-item">
              <base-radio-button
                :checked="extra_user_info.real_estate_owner"
                @click="extra_user_info.real_estate_owner = true"
              />
              <div class="role-item-desc" @click="extra_user_info.real_estate_owner = true">
                {{ $t('message.signUp.extraBlock.realEstate.yes') }}
              </div>
            </div>
            <div class="role-item">
              <base-radio-button
                :checked="!extra_user_info.real_estate_owner"
                @click="extra_user_info.real_estate_owner = false"
              />
              <div class="role-item-desc" @click="extra_user_info.real_estate_owner = false">
                {{ $t('message.signUp.extraBlock.realEstate.no') }}
              </div>
            </div>
          </div>
          <div class="middle-input-container"></div>
        </div>

        <div class="sign-up-block-container">
          <div class="middle-input-container">
            <div class="input-wrapper">
              <div class="input-label">
                {{ $t('message.signUp.extraBlock.dependensNumber.title') }}
              </div>
              <div class="half-middle-input-block">
                <base-text-input
                  v-model="extra_user_info.dependens_number"
                  :name="'dependensNumber'"
                  :validate-rules="'dependensNumber'"
                  :mask-pattern="'####'"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="sign-up-block-container row-radiobtn-container">
          <div class="middle-input-container">
            <div class="input-label extra-data-radiobtn-input-label">
              {{ $t("message.signUp.extraBlock.childExpenses.title") }}
            </div>
          </div>
          <div class="middle-input-container extra-radiobtn-block">
            <div class="role-item">
              <base-radio-button
                :checked="extra_user_info.child_expenses"
                @click="extra_user_info.child_expenses = true"
              />
              <div class="role-item-desc" @click="extra_user_info.child_expenses = true">
                {{ $t('message.signUp.extraBlock.childExpenses.yes') }}
              </div>
            </div>
            <div class="role-item">
              <base-radio-button
                :checked="!extra_user_info.child_expenses"
                @click="extra_user_info.child_expenses = false"
              />
              <div class="role-item-desc" @click="extra_user_info.child_expenses = false">
                {{ $t('message.signUp.extraBlock.childExpenses.no') }}
              </div>
            </div>
          </div>
          <div class="middle-input-container"></div>
        </div>

        <div class="sign-up-block-container">
          <div class="middle-input-container">
            <div class="input-wrapper">
              <div class="input-label">
                {{ $t('message.signUp.extraBlock.totalIncome.title') }}
              </div>
              <div class="half-middle-input-block">
                <base-text-input
                  v-model="extra_user_info.total_income"
                  :name="'totalIncome'"
                  :validate-rules="'totalIncome'"
                  :mask-pattern="'######'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sign-up-block">
        <div class="sign-up-block-title">
          <div class="step-block">{{ userData.role === 'borrower' ? '7.' : '6.' }}</div>
          <div class="step-block-desc">
            {{ $t("message.signUp.basicBlock.title") }}
          </div>
        </div>
        <div class="sign-up-block-container">
          <div class="middle-input-container">
            <base-text-input
              :default-value="userData.email"
              :label="$t('message.signUp.basicBlock.email.title')"
              :disabled="signUpDisabledFields.email"
              v-model="userData.email"
              :name="'email'"
            />
          </div>

          <div class="middle-input-container">
            <base-text-input
              :label="$t('message.signUp.basicBlock.keyWord.title')"
              v-model="userData.key_word"
              :name="'keyWord'"
              :validate-rules="'keyWord'"
              :is-have-notice="true"
              :notice-message="$t('message.signUp.basicBlock.keyWord.noticeMsg')"
            />
          </div>

          <div class="middle-input-container">
            <base-password-input
              :label="$t('message.signUp.passwordBlock.password.title')"
              v-model="userData.password"
              :validate-rules="'password'"
              :name="'password'"
            />
          </div>
        </div>

        <div class="sign-up-block-container">
          <div class="middle-input-container">
            <base-text-input
              :label="$t('message.signUp.basicBlock.msisdn.title')"
              v-model="userData.phone_number"
              :default-value="userData.phone_number"
              :disabled="signUpDisabledFields.phone_number"
              :name="'msisdn'"
              :validate-rules="'msisdn'"
              :mask-pattern="'+### (##) ### ## ##'"
            />
          </div>
          <div class="middle-input-container">
            <div class="input-wrapper">
              <div class="input-label">
                {{ $t("message.signUp.basicBlock.otp.title") }}
              </div>
              <div class="otp-block">
                <base-text-input
                  v-model="userData.otp"
                />
              </div>
              <div class="input-error-block send-otp-block" @click="getOtpCode()">
                {{ $t("message.signUp.basicBlock.otp.sendOtp") }}
              </div>
            </div>
          </div>
          <div class="middle-input-container"></div>
        </div>
      </div>

      <div class="sign-up-block">
        <!-- <div class="offer-item">
          <div
            class="check-box-btn"
            :class="{ 'check-box-checked': isDataFullAndCorrect }"
            @click.stop="offerToggle('isDataFullAndCorrect')"
          >
            <img
              v-if="isDataFullAndCorrect"
              class="check-box-image"
              src="../../../public/custom/images/check.svg"
              alt="Checket image"
            />
          </div>
          <div
            class="check-box-label"
            @click.stop="offerToggle('isDataFullAndCorrect')"
          >
            <span>{{ $t("message.signUp.isDataFullAndCorrect.text") }}</span>
          </div>
        </div> -->
        <div class="offer-item">
          <div
            class="check-box-btn"
            :class="{ 'check-box-checked': isAgreeWithServiceRules }"
            @click.stop="offerToggle('isAgreeWithServiceRules')"
          >
            <img
              v-if="isAgreeWithServiceRules"
              class="check-box-image"
              src="../../../public/custom/images/check.svg"
              alt="Checket image"
            />
          </div>
          <div
            class="check-box-label"
            @click.stop="offerToggle('isAgreeWithServiceRules')"
          >
            <span>{{ $t("message.signUp.isAgreeWithServiceRules.text") }}</span>
            <a class="check-box-link" :href="require('../../../public/static/rules.pdf')" target="_blank">{{
              $t("message.signUp.isAgreeWithServiceRules.link")
            }}</a>
            <span>{{ $t("message.signUp.isAgreeWithServiceRules.secondText") }}</span>
            <a class="check-box-link" :href="require('../../../public/static/personalDataProcessing.pdf')" target="_blank">{{
              $t("message.signUp.isAgreeWithServiceRules.secondLink")
            }}</a>
          </div>
        </div>

        <div class="offer-item">
          <div
            class="check-box-btn"
            :class="{ 'check-box-checked': isAgreeWithServiceAgreement }"
            @click.stop="offerToggle('isAgreeWithServiceAgreement')"
          >
            <img
              v-if="isAgreeWithServiceAgreement"
              class="check-box-image"
              src="../../../public/custom/images/check.svg"
              alt="Checket image"
            />
          </div>
          <div
            class="check-box-label"
            @click.stop="offerToggle('isAgreeWithServiceAgreement')"
          >
            <span>{{
              $t("message.signUp.isAgreeWithServiceAgreement.textFirst")
            }}</span>
            <a class="check-box-link" :href="require('../../../public/static/serviceContract.pdf')" target="_blank">{{
              $t("message.signUp.isAgreeWithServiceAgreement.link")
            }}</a>
            <span>{{
              $t("message.signUp.isAgreeWithServiceAgreement.textSecond")
            }}</span>
          </div>
        </div>

        <div class="offer-item">
          <div
            class="check-box-btn"
            :class="{ 'check-box-checked': isAgreeWithPersonalDataActions }"
            @click.stop="offerToggle('isAgreeWithPersonalDataActions')"
          >
            <img
              v-if="isAgreeWithPersonalDataActions"
              class="check-box-image"
              src="../../../public/custom/images/check.svg"
              alt="Checket image"
            />
          </div>
          <div
            class="check-box-label"
            @click.stop="offerToggle('isAgreeWithPersonalDataActions')"
          >
            <span>{{
              $t("message.signUp.isAgreeWithPersonalDataActions.textFirst")
            }}</span>
            <a class="check-box-link" target="_blank" :href="require('../../../public/static/personalDataAgreement.pdf')">{{
              $t("message.signUp.isAgreeWithPersonalDataActions.link")
            }}</a>
            <span>{{
              $t("message.signUp.isAgreeWithPersonalDataActions.textSecond")
            }}</span>
          </div>
        </div>
        <!-- <div class="offer-item" v-if="userData.role === 'borrower'">
          <div
            class="check-box-btn"
            :class="{ 'check-box-checked': isAgreeToGetBankReport }"
            @click.stop="offerToggle('isAgreeToGetBankReport')"
          >
            <img
              v-if="isAgreeToGetBankReport"
              class="check-box-image"
              src="../../../public/custom/images/check.svg"
              alt="Checket image"
            />
          </div>
          <div
            class="check-box-label"
            @click.stop="offerToggle('isAgreeToGetBankReport')"
          >
            <span>{{
              $t("message.signUp.isAgreeToGetBankReport.textFirst")
            }}</span>
            <span>{{
              $t("message.signUp.isAgreeToGetBankReport.link")
            }}</span>
            <span>{{
              $t("message.signUp.isAgreeToGetBankReport.textSecond")
            }}</span>
          </div>
        </div> -->
      </div>

      <div class="sign-up-block btn-block">
        <div class="btn-container">
          <base-button
            :text="$t('message.signUp.signUpBtn')"
            @click="signUp()"
            :disabled="isSignUpButtonDisabled"
            :isLoading="isSignUpBtnLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseDatepicker from "../../components/base/BaseDatepicker.vue";
import BaseSelect from "../../components/base/BaseSelect.vue";
import BaseRadioButton from "../../components/base/BaseRadioButton.vue";
import BasePasswordInput from "../../components/base/BasePasswordInput.vue";
import BaseTextInput from "../../components/base/BaseTextInput.vue";
import BaseTextareaInput from "../../components/base/BaseTextareaInput.vue";

import CONSTANTS from '../../constants/constants';

import signUpValidationMixin from '../../mixins/signUp/signUpValidationMixin';

import { mapGetters } from 'vuex';

export default {
  name: "SignUp",
  mixins: [signUpValidationMixin],
  inject: ['$httpService'],
  components: {
    BaseDatepicker,
    BaseSelect,
    BaseRadioButton,
    BasePasswordInput,
    BaseTextInput,
    BaseTextareaInput
  },
  async created() {
    const { code } = this.$route.query;
    
    code ? await this.$store.dispatch('getMsiProfile', code) : this.$router.push({ name: 'main' });

    this.userData = {...this.msiData};
  },
  data() {
    return {
      CONSTANTS,
      isAddressLivingAndRegistrationTheSame: true,
      isDataFullAndCorrect: true,
      isAgreeWithServiceRules: false,
      isAgreeWithPersonalDataActions: false,
      isAgreeWithServiceAgreement: false,
      isAgreeToGetBankReport: true,
      work_info: {
        employment_type: '1',
        scope_of_employment_type: '1',
        organization_name: '',
        organization_unp: '',
        organization_phone_number: '',
        job_position_type: '1',
        job_position_name: '',
        workExperience: ''
      },
      extra_user_info: {
        education: '1',
        drivers_license: true,
        car_owner: true,
        real_estate_owner: true,
        family_status: '1',
        dependens_number: '',
        child_expenses: true,
        total_income: ''
      },
      userData: {
        name_ru: {
          family_name_ru: '',
          given_name_ru: '',
          middle_name_ru: '',
        },
          id_document: {
          type: '3',
          authority: ''
        },
        role: 'lender'
      },
      living_address_str: '',
      message_id: '',
      isSignUpBtnLoading: false
    };
  },
  computed: {
    ...mapGetters(['msiData', 'signUpDisabledFields', 'isLoading']),
    isSignUpButtonDisabled() {
      return !this.isOffersAccepted || this.isMainDataIncorrect || this.isJobDataIncorrect ||
        this.isIdDataIncorrect || this.isContactDataIncorrect || this.isAddressDataIncorrect || this.isHasValidationsErrors ||
        this.isExtraDataIncorrect;
    },
    isHasValidationsErrors() {
      return this.errors.items.length > 0;
    },
    isOtherJobPositionType() {
      const otherJobPositionType = '8';
      return this.work_info.job_position_type === otherJobPositionType;
    },
  },
  methods: {
    addressToggle() {
      return (this.isAddressLivingAndRegistrationTheSame =
        !this.isAddressLivingAndRegistrationTheSame);
    },
    offerToggle(offerItem) {
      return (this[offerItem] = !this[offerItem]);
    },
    async getOtpCode() {
        try {
          const response = await this.$httpService.auth.getOtpCode(this.userData.phone_number);

          this.message_id = response.data.message_id;
          this.$toast({text: this.$t('message.signIn.otpToastMsg')});
        } catch (error) {
          this.$router.push({name: 'SignIn'});
        }
    },
    async signUp() {
      this.isSignUpBtnLoading = true;
      const otp = +this.userData.otp;
      const login = this.userData.phone_number;
      const living_address_str = this.isAddressLivingAndRegistrationTheSame ? undefined : this.living_address_str;
      const extra_user_info = this.userData.role === 'borrower' ? this.extra_user_info : undefined;
      const agreePersonalDataProcessing = this.isAgreeWithPersonalDataActions;
      const payload = {...this.userData, work_info: this.work_info, otp, login, extra_user_info, living_address_str, agreePersonalDataProcessing};
      
      try {
        const response = await this.$httpService.msi.signUp(payload);

        const token = response.data.token;
        localStorage.setItem('token', token);

        this.isSignUpBtnLoading = false;
        this.$router.push({name: 'profile'});
      } catch (error) {
        this.isSignUpBtnLoading = false;
      }
    },
    goToMain() {
      this.$router.push({ name: 'main' });
    }
  },
};
</script>

<style lang="scss" scoped>
.sign-up-wrapper {
  @include base-page-wrapper;

  background-color: var(--sign-up-wrapper-bgc);
}

.sign-up-header {
  width: 100%;
  height: 90px;
  padding: 0 5%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--sign-up-header-bgc);
}

.logo {
  width: 150px;
  height: 31px;
  cursor: pointer;
}

.header-icon {
  height: 100%;
  max-width: 60%;
}

.sign-up-container {
  width: 1146px;
  max-width: 95%;
  padding: 70px 0 100px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  margin-bottom: 20px;
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 40px;
  line-height: 125%;
  text-align: center;
  color: var(--sign-up-title-color);
}

.description {
  width: 356px;
  max-width: 80%;
  margin-bottom: 45px;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: var(--sign-up-desc-color);
}

.sign-up-block {
  width: 100%;
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
}

.sign-up-block-title {
  display: flex;
  align-items: flex-end;
  margin-bottom: 40px;
}

.step-block {
  height: 45px;
  width: 45px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: var(--step-block-bgc);
  color: var(--step-block-color);
  font-weight: 600;
  font-size: 26px;
  line-height: 35px;
}

.step-block-desc {
  font-weight: 600;
  font-size: 26px;
  line-height: 42px;
  color: var(--step-block-desc-color);
}

.sign-up-block-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.row-block-container {
  flex-direction: column;
  justify-content: flex-start;
}

.middle-input-container {
  width: 30%;
  min-width: 343px;
}

.large-input-container {
  width: 65%;
  min-width: 744px;
}

.same-address-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.same-address-title {
  margin-left: 10px;
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  color: #333333;
  cursor: pointer;
}

.middle-double-container {
  width: 30%;
  min-width: 343px;
  display: flex;
  justify-content: space-between;
}

.small-input-container {
  width: calc(50% - 10px);
}

.input-wrapper {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.input-label {
  @include base-input-label;
}

.extra-data-radiobtn-input-label {
  margin-bottom: 0;
}

.input-block {
  @include base-input-block;
}

.gender-block,
.role-block {
  width: 100%;
  height: 52px;
  display: flex;
  align-items: center;
}

.gender-item,
.role-item {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #333333;
}

.gender-item:first-of-type,
.role-item:first-of-type {
  margin-right: 37px;
}

.gender-name {
  margin-left: 10px;
  opacity: 0.5;
}

.role-item-desc {
  margin-left: 10px;
  cursor: pointer;
}

.datepicker-block {
  width: 100%;
  height: 54px;
  border-radius: var(--base-input-border-radius);
  position: relative;
}


.otp-block {
  width: 50%;
  height: 54px;
  border-radius: var(--base-input-border-radius);
}

.invalid-input-block {
  border: 1px solid var(--base-input-invalid-border-bgc);
}

.base-input {
  @include base-input;
}

.input-error-block {
  @include base-input-error-block;
}

.middle-block-container {
  width: 65%;
}

.same-address-block,
.offer-block,
.offer-item {
  margin-bottom: 30px;
  display: flex;
  align-items: flex-start;
}

.check-box-btn {
  @include base-check-box;
}

.check-box-label {
  @include base-check-box-label;
}

.citizenship-block {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.radio-btn-block {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-end;
  opacity: 0.8;
}

.radio-btn-label {
  @include base-radio-btn-label;
  margin-left: 10px;
  margin-bottom: 3px;
  cursor: default;
}

.radio-btn-disabled {
  cursor: default;
}

.notice-block {
  margin-bottom: 25px;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  color: var(--sign-up-dovks-upload-notice-color);
}

.btn-container {
  width: 300px;
  height: 65px;
}

.send-otp-block {
  margin-top: 3px;
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  letter-spacing: 0.01em;
  text-decoration-line: underline;
  color: #41BF7B;
  cursor: pointer;
  font-family: 'Open Sans';
  user-select: none;
}

.half-middle-input-block ::v-deep {
  width: 50%;
}

.row-radibtn-container {
  display: flex;
  align-items: center;
}

.extra-radiobtn-block {
  display: flex;
}

.row-radiobtn-container {
  margin-bottom: 30px;
}

@media screen and (max-width: 800px) {
  .large-input-container {
    width: 100%;
    min-width: 100%;
  }
}

@media screen and (max-width: 740px) {
  .extra-data-radiobtn-input-label {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 600px) {
  .middle-input-container {
    width: 100%;
    min-width: 100%;
  }

  .btn-block {
    align-items: center;
  }

  .step-block-desc {
    width: calc(100% - 65px);
  }

  .sign-up-block-title {
    align-items: flex-start;
  }

  .same-address-title {
    width: calc(100% - 28px);
  }
}
</style>
